import { Heading, Warning, theme } from '@lmc/ui-kit'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import styled from 'styled-components'
import { Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { AbsenceType } from '@lmc/ts-common'

type DeleteIndividualAbsenceModalProps = {
  isModalVisible: boolean
  setIsModalVisible: (isVisible: boolean) => void
  userName: string
  absenceType?: AbsenceType
  isDeleteLoading: boolean
  deleteAbsence?: any
}

const DeleteIndividualAbsenceModal = ({
  isModalVisible,
  setIsModalVisible,
  deleteAbsence,
  isDeleteLoading,
  userName,
  absenceType,
}: DeleteIndividualAbsenceModalProps) => {
  const { t } = useTranslation()
  const onCancelClick = () => {
    setIsModalVisible(false)
  }

  return (
    <Modal
      closable={false}
      open={isModalVisible}
      cancelText={
        <CancelButton>
          <CloseOutlined />
          <Text>{t('CANCEL')}</Text>
        </CancelButton>
      }
      confirmLoading={isDeleteLoading}
      footer={[
        <ModalFooter>
          <Button onClick={onCancelClick}>
            <CloseOutlined />
            {t('CANCEL')}
          </Button>
          <Button onClick={deleteAbsence} variant="danger">
            {t('DELETE')}
          </Button>
        </ModalFooter>,
      ]}
    >
      <TitleContainer>
        <Warning size={24} color={theme.color.status.warning} />
        <Title level={3}>
          {t('INDIVIDUAL_ABSENCE_DELETE_TITLE', {
            user: userName,
            type: absenceType?.name,
          })}
        </Title>
      </TitleContainer>
      <Divider />
      <DescriptionContainer>
        <Text>
          {t('INDIVIDUAL_ABSENCE_DELETE_DESCRIPTION', {
            user: userName,
            type: absenceType?.name,
          })}
        </Text>
      </DescriptionContainer>
      <Divider />
    </Modal>
  )
}

const ModalFooter = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`

const DescriptionContainer = styled.div`
  margin: 24px 0;
`

const CancelButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

export default DeleteIndividualAbsenceModal
